/* ============================================================
   Global theme JS — original code
   Header toggles · cart drawer (AJAX) · product gallery with
   hover magnify + click lightbox (zoom & pan) · variant picker
   ============================================================ */

(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  // Normalize a Shopify image URL for comparison: same image, regardless of
  // protocol, size params (?width=), version query, or _WxH filename suffixes.
  function imgKey(u) {
    if (!u) return '';
    u = String(u).replace(/^https?:/, '').split('?')[0];
    return u.replace(/_(\d+x\d*|x\d+)(?=\.[a-z]{2,5}$)/i, '');
  }

  /* ---------------- header ---------------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-menu-toggle]'))) {
      var m = document.querySelector('.mobile-menu');
      if (m) m.classList.toggle('is-open');
    }
    if ((t = e.target.closest('[data-search-toggle]'))) {
      var s = document.querySelector('.search-bar');
      if (s) {
        s.classList.toggle('is-open');
        var input = s.querySelector('input[type="search"]');
        if (s.classList.contains('is-open') && input) input.focus();
      }
    }
  });

  /* ---------------- cart drawer ---------------- */
  var drawer = {
    el: null,
    overlay: null,
    threshold: 7500, // cents; overridden by data attr
    protectVariant: 0,
    protectBusy: false,
    lastSig: null,
    lastCart: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-drawer-overlay]');
      if (!this.el) return;
      var th = parseInt(this.el.getAttribute('data-free-shipping-cents'), 10);
      if (!isNaN(th)) this.threshold = th;
      var protectEl = this.el.querySelector('[data-cart-protect]');
      if (protectEl) {
        this.protectVariant = parseInt(protectEl.getAttribute('data-protect-variant'), 10) || 0;
        var self0 = this;
        protectEl.addEventListener('change', function (e) {
          var box = e.target.closest('[data-protect-toggle]');
          if (!box) return;
          protectEl.classList.add('is-busy');
          // Optimistic subtotal: show the new amount immediately; the cart
          // request confirms it in the background.
          if (self0.lastCart) {
            var pc = parseInt(protectEl.getAttribute('data-protect-price-cents'), 10) || 0;
            self0.setSubtotal(self0.lastCart.total_price + (box.checked ? pc : -pc));
          }
          if (box.checked) {
            try { sessionStorage.removeItem('aloviesProtectOff'); } catch (err) {}
            self0.protectAdd();
          } else {
            try { sessionStorage.setItem('aloviesProtectOff', '1'); } catch (err) {}
            self0.protectRemove();
          }
        });
      }

      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]') || e.target === self.overlay) self.close();
        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        var remove = e.target.closest('[data-line-remove]');
        if (minus || plus || remove) {
          e.preventDefault();
          var line = e.target.closest('[data-line-key]');
          if (!line) return;
          var key = line.getAttribute('data-line-key');
          var qty = parseInt(line.getAttribute('data-line-qty'), 10) || 0;
          if (plus) qty += 1;
          if (minus) qty -= 1;
          if (remove) qty = 0;
          self.change(key, Math.max(0, qty));
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      // Intercept product form submits for AJAX add
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[data-ajax-cart]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { return self.refresh(); })
          .then(function () { self.open(); })
          .catch(function () { window.location.href = '/cart'; })
          .finally(function () { if (btn) btn.removeAttribute('disabled'); });
      });

      this.refresh();
    },

    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
    },

    change: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); });
    },

    protectLine: function (cart) {
      var pv = this.protectVariant;
      if (!pv) return null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === pv) return cart.items[i];
      }
      return null;
    },

    protectOptedOut: function () {
      try { return sessionStorage.getItem('aloviesProtectOff') === '1'; } catch (err) { return false; }
    },

    protectAdd: function () {
      var self = this;
      if (!this.protectVariant || this.protectBusy) return;
      this.protectBusy = true;
      // Already in the cart? Resync the UI instead of stacking a second unit.
      if (this.lastCart && this.protectLine(this.lastCart)) {
        this.refresh().finally(function () { self.protectDone(); });
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.protectVariant, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); })
        .finally(function () { self.protectDone(); });
    },

    protectDone: function () {
      this.protectBusy = false;
      var row = this.el ? this.el.querySelector('[data-cart-protect]') : null;
      if (row) row.classList.remove('is-busy');
      // Reconcile the toggle with the settled cart state — the render that ran
      // mid-request skipped the checkbox while the busy flag was up.
      if (this.lastCart) this.protectSync(this.lastCart);
    },

    protectRemove: function () {
      var self = this;
      if (!this.protectVariant || this.protectBusy) return;
      this.protectBusy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(this.protectVariant), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // change.js returns the full cart — render straight from it
          // instead of paying for a second request.
          if (cart && cart.items) { self.render(cart); } else { return self.refresh(); }
        })
        .finally(function () { self.protectDone(); });
    },

    setSubtotal: function (cents) {
      var foot = this.el ? this.el.querySelector('[data-cart-subtotal]') : null;
      if (!foot) return;
      var newTotal = money(cents);
      // Skip when already showing (or mid-fade to) this amount, so the server
      // confirmation doesn't re-run the fade after an optimistic update.
      if (foot.textContent === newTotal || this._pendingTotal === newTotal) return;
      this._pendingTotal = newTotal;
      foot.style.transition = 'opacity 0.14s ease';
      foot.style.opacity = '0';
      setTimeout(function () {
        foot.textContent = newTotal;
        foot.style.opacity = '1';
      }, 140);
    },

    protectSync: function (cart) {
      // Auto-on: keep protection in any cart with real items unless the
      // customer switched it off this session. Never protect an empty cart.
      var line = this.protectLine(cart);
      var others = cart.items.length - (line ? 1 : 0);
      var row = this.el ? this.el.querySelector('[data-cart-protect]') : null;
      if (row) {
        row.hidden = others === 0;
        var box = row.querySelector('[data-protect-toggle]');
        // Optimistic UI: while a toggle request is in flight, keep the state
        // the customer set instead of snapping back mid-request.
        if (box && !this.protectBusy) box.checked = !!line;
      }
      if (this.protectBusy) return;
      if (others === 0 && line) { this.protectRemove(); return; }
      if (others > 0 && !line && !this.protectOptedOut()) { this.protectAdd(); return; }
      if (line && line.quantity > 1) { this.change(line.key, 1); }
    },

    refresh: function () {
      var self = this;
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },

    render: function (cart) {
      var protectItem = this.protectLine(cart);
      var protectQty = protectItem ? protectItem.quantity : 0;
      var protectPrice = protectItem ? protectItem.final_line_price : 0;
      var shownCount = cart.item_count - protectQty;
      var shownItems = cart.items.filter(function (it) { return !protectItem || it.key !== protectItem.key; });

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = shownCount;
        el.style.display = shownCount > 0 ? 'flex' : 'none';
      });
      if (!this.el) return;
      this.lastCart = cart;
      this.protectSync(cart);
      var wrap = this.el.querySelector('[data-cart-items]');
      this.setSubtotal(cart.total_price);

      var meter = this.el.querySelector('[data-shipping-meter]');
      if (meter) {
        var merch = cart.total_price - protectPrice; // protection doesn't count toward free shipping
        var fill = meter.querySelector('.shipping-meter__fill');
        var label = meter.querySelector('[data-meter-label]');
        var remaining = this.threshold - merch;
        var pct = Math.min(100, Math.round((merch / this.threshold) * 100));
        if (fill) fill.style.width = pct + '%';
        if (label) {
          label.textContent = remaining > 0
            ? money(remaining) + ' away from free US shipping'
            : 'You have free US shipping';
        }
      }

      if (!wrap) return;
      // Only rebuild the line items when they actually changed — a protection
      // toggle alone updates the totals without re-rendering (and flashing)
      // the whole list.
      var sig = shownItems.map(function (it) { return it.key + ':' + it.quantity; }).join('|');
      if (sig === this.lastSig) return;
      this.lastSig = sig;
      if (!shownItems.length) {
        wrap.innerHTML = '<div class="empty-state" style="padding:48px 0"><p class="muted">Your cart is empty.</p></div>';
        return;
      }
      wrap.innerHTML = shownItems.map(function (item) {
        var opts = item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="muted">' + item.variant_title + '</span>' : '';
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="">'
          : '<div style="width:72px;height:72px;background:var(--c-alt)"></div>';
        return (
          '<div class="cart-line" data-line-key="' + item.key + '" data-line-qty="' + item.quantity + '">' +
            img +
            '<div class="cart-line__info">' +
              '<span class="cart-line__title">' + item.product_title + '</span>' + opts +
              '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px">' +
                '<span class="qty"><button data-qty-minus aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button data-qty-plus aria-label="Increase">+</button></span>' +
                '<span style="font-weight:700">' + money(item.final_line_price) + '</span>' +
              '</div>' +
              '<a href="#" data-line-remove class="muted" style="font-size:12px;text-decoration:underline">Remove</a>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
  };


  /* ---------------- smooth accordions ---------------- */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('.accordion summary, .facets summary');
    if (!sum) return;
    var det = sum.parentElement;
    var body = sum.nextElementSibling;
    if (!det || det.tagName !== 'DETAILS' || !body || !body.animate) return;
    e.preventDefault();
    if (det.__animating) return;
    det.__animating = true;
    var dur = 300;
    var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    if (det.open) {
      var closing = body.animate(
        [
          { height: body.scrollHeight + 'px', opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        { duration: dur, easing: ease }
      );
      closing.onfinish = function () {
        det.open = false;
        det.__animating = false;
      };
    } else {
      det.open = true;
      var opening = body.animate(
        [
          { height: '0px', opacity: 0 },
          { height: body.scrollHeight + 'px', opacity: 1 }
        ],
        { duration: dur, easing: ease }
      );
      opening.onfinish = function () { det.__animating = false; };
    }
  });

  /* ---------------- product gallery ---------------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var mainImg = main ? main.querySelector('img') : null;
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !mainImg) return;

    var sources = [];
    thumbs.forEach(function (t) { sources.push({ full: t.getAttribute('data-full'), alt: t.querySelector('img') ? t.querySelector('img').alt : '' }); });
    if (!sources.length) sources = [{ full: mainImg.getAttribute('data-full') || mainImg.src, alt: mainImg.alt }];
    var index = 0;

    function show(i) {
      index = (i + sources.length) % sources.length;
      mainImg.style.opacity = '0';
      var next = sources[index];
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        mainImg.src = next.full;
        mainImg.alt = next.alt || mainImg.alt;
        requestAnimationFrame(function () { mainImg.style.opacity = '1'; });
      };
      pre.src = next.full;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === index); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });

    // click → lightbox
    main.addEventListener('click', function () { lightbox.open(sources, index); });

    // variant image jump — match by normalized URL so resized gallery URLs
    // line up with the raw variant image URL from the product JSON
    root.addEventListener('gallery:goto', function (e) {
      var key = imgKey(e.detail);
      if (!key) return;
      var i = sources.findIndex(function (s) { return imgKey(s.full) === key; });
      if (i > -1) {
        if (i !== index) show(i);
      } else {
        // variant image isn't among the thumbnails (e.g. beyond the thumb cap):
        // swap the main image directly with the same fade
        index = -1;
        mainImg.style.opacity = '0';
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          mainImg.src = e.detail;
          requestAnimationFrame(function () { mainImg.style.opacity = '1'; });
        };
        pre.src = e.detail;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      }
    });
  }

  /* ---------------- lightbox with zoom & pan ---------------- */
  var lightbox = {
    el: null, img: null, sources: [], index: 0,
    scale: 1, tx: 0, ty: 0, panning: false, sx: 0, sy: 0,
    pinch: null,

    build: function () {
      if (this.el) return;
      var el = document.createElement('div');
      el.className = 'lightbox';
      el.innerHTML =
        '<div class="lightbox__img-wrap"><img alt="" draggable="false"></div>' +
        '<button class="lightbox__close" aria-label="Close">&times;</button>' +
        '<button class="lightbox__prev" aria-label="Previous">&#8249;</button>' +
        '<button class="lightbox__next" aria-label="Next">&#8250;</button>' +
        '<span class="lightbox__hint">Scroll or pinch to zoom &middot; drag to pan &middot; Esc to close</span>';
      document.body.appendChild(el);
      this.el = el;
      this.img = el.querySelector('img');
      var self = this;

      el.querySelector('.lightbox__close').addEventListener('click', function () { self.close(); });
      el.querySelector('.lightbox__prev').addEventListener('click', function () { self.show(self.index - 1); });
      el.querySelector('.lightbox__next').addEventListener('click', function () { self.show(self.index + 1); });
      el.addEventListener('click', function (e) { if (e.target === el || e.target.classList.contains('lightbox__img-wrap')) self.close(); });
      document.addEventListener('keydown', function (e) {
        if (!self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.show(self.index - 1);
        if (e.key === 'ArrowRight') self.show(self.index + 1);
      });

      el.addEventListener('wheel', function (e) {
        e.preventDefault();
        var next = Math.min(5, Math.max(1, self.scale - e.deltaY * 0.0022));
        self.scale = next;
        if (next === 1) { self.tx = 0; self.ty = 0; }
        self.apply();
      }, { passive: false });

      this.img.addEventListener('pointerdown', function (e) {
        if (self.scale <= 1) return;
        self.panning = true; self.sx = e.clientX - self.tx; self.sy = e.clientY - self.ty;
        self.img.classList.add('is-panning');
        self.img.setPointerCapture(e.pointerId);
      });
      this.img.addEventListener('pointermove', function (e) {
        if (!self.panning) return;
        self.tx = e.clientX - self.sx; self.ty = e.clientY - self.sy;
        self.apply(true);
      });
      this.img.addEventListener('pointerup', function () {
        self.panning = false;
        self.img.classList.remove('is-panning');
      });

      // touch pinch
      el.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 2) return;
        e.preventDefault();
        var d = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        if (self.pinch == null) { self.pinch = d / self.scale; return; }
        self.scale = Math.min(5, Math.max(1, d / self.pinch));
        self.apply(true);
      }, { passive: false });
      el.addEventListener('touchend', function () { self.pinch = null; });

      // double click / tap toggles zoom
      this.img.addEventListener('dblclick', function () {
        self.scale = self.scale > 1 ? 1 : 2.4;
        if (self.scale === 1) { self.tx = 0; self.ty = 0; }
        self.apply();
      });
    },

    apply: function (instant) {
      this.img.classList.toggle('no-anim', !!instant);
      this.img.style.transform = 'translate(' + this.tx + 'px,' + this.ty + 'px) scale(' + this.scale + ')';
    },

    open: function (sources, index) {
      this.build();
      this.sources = sources;
      this.show(index || 0);
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    show: function (i) {
      this.index = (i + this.sources.length) % this.sources.length;
      this.scale = 1; this.tx = 0; this.ty = 0;
      this.apply(true);
      var self = this;
      this.img.style.transition = 'opacity 0.2s ease';
      this.img.style.opacity = '0';
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        self.img.src = self.sources[self.index].full;
        requestAnimationFrame(function () {
          self.img.style.opacity = '1';
          setTimeout(function () { self.img.style.transition = ''; }, 220);
        });
      };
      pre.src = this.sources[this.index].full;
      var nav = this.sources.length > 1 ? '' : 'none';
      this.el.querySelector('.lightbox__prev').style.display = nav;
      this.el.querySelector('.lightbox__next').style.display = nav;
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };

  /* ---------------- variant picker ---------------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var btn = root.querySelector('[data-add-button]');
    var btnLabel = root.querySelector('[data-add-label]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      root.querySelectorAll('[data-option-label]').forEach(function (lab) {
        var gi = parseInt(lab.getAttribute('data-option-label'), 10);
        var name = lab.getAttribute('data-option-name');
        lab.textContent = name + ' — ' + (opts[gi] || '');
      });
      if (!match) {
        if (btn) btn.setAttribute('disabled', 'disabled');
        if (btnLabel) btnLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (btn) {
        if (match.available) {
          btn.removeAttribute('disabled');
          if (btnLabel) btnLabel.textContent = 'Add to cart — ' + money(match.price);
        } else {
          btn.setAttribute('disabled', 'disabled');
          if (btnLabel) btnLabel.textContent = 'Sold out';
        }
      }
      if (match.featured_image && match.featured_image.src) {
        var gal = document.querySelector('[data-gallery]');
        if (gal) gal.dispatchEvent(new CustomEvent('gallery:goto', { detail: match.featured_image.src }));
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) update();
    });
    update();
  }

  /* ---------------- collection sort ---------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-select]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  });

  /* ---------------- boot ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer.init();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-form-wrap]').forEach(initVariantPicker);
  });
})();
